<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Saisie guidée {{ ligneSaisieGuidee ? ligneSaisieGuidee.nomCritere : ''}}
        </div>
        <div class="modal-body">
            <div class="tree">
                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                    <!-- This is the tree node template for leaf nodes -->
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (mousedown)="use(node)"
                        class="select-tree">
                        <!-- use a disabled button to provide padding for tree leaf -->
                        <button mat-icon-button disabled></button>
                        {{node.name}}
                    </mat-tree-node>
                    <!-- This is the tree node template for expandable nodes -->
                    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <p (mousedown)="use(node)" style="cursor: pointer;">
                            {{node.name}}
                        </p>
                    </mat-tree-node>
                </mat-tree>
            </div>
            <frg-button (click)="closeModal()">Fermer</frg-button>
        </div>        
    </div>
</div>
<div class="modal-background"></div>